/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_House_Promo_CtaInputs */

const en_directory_house_promo_cta = /** @type {(inputs: Directory_House_Promo_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.name}`)
};

const zh_directory_house_promo_cta = /** @type {(inputs: Directory_House_Promo_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`试试 ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Try {name}" |
*
* @param {Directory_House_Promo_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_house_promo_cta = /** @type {((inputs: Directory_House_Promo_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_House_Promo_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_house_promo_cta(inputs)
	return zh_directory_house_promo_cta(inputs)
});
export { directory_house_promo_cta as "directory.house_promo.cta" }